import { ShouldHideWidgetProps } from '../actions/useApi';

// ...existing code...
export const computeWidgetDisplay = (props: ShouldHideWidgetProps): boolean => {
    const { widget_display_condition, widget_display_action, widget_display_url_pattern } = props;
    console.log('$$', { widget_display_condition, widget_display_action, widget_display_url_pattern });
    if (!widget_display_condition || !widget_display_action || !widget_display_url_pattern) {
        return true; // Default to showing the widget
    }

    const currentPath = props.currentPath;

    let match = false;
    console.log('[computewidgetdisplay] checking path', currentPath, widget_display_url_pattern, props )
    switch (widget_display_action) {
        case 'contains':
            match = currentPath.includes(widget_display_url_pattern);
            break;
        case 'matches':
            match = currentPath === widget_display_url_pattern;
            break;
        case 'startsWith':
            match = currentPath.startsWith(widget_display_url_pattern);
            break;
        case 'endsWith':
            match = currentPath.endsWith(widget_display_url_pattern);
            break;
    }

    if (widget_display_condition === 'hide' && match) {
        console.log('[computewidgetdisplay] Hide the widget because widget_displaY_condition is hide')
        return false; // Hide the widget
    }

    if (widget_display_condition === 'show' && !match) {
        console.log('[computewidgetdisplay] Hide the widget because widget_displaY_condition is show and there is no match')
        return false; // Hide the widget if condition is show and there's no match
    }
    console.log('[computewidgetdisplay] show the widget')
    return true; // Show the widget
};

